import angular from 'angular';

import InfiniteScrollDirective from './infinite-scroll.directive';

const InfiniteScrollModule = angular
    .module('control-room.commons.layout.directives.infinite-scroll', [])
    .directive('crInfiniteScroll', ['$window', InfiniteScrollDirective]);

export default InfiniteScrollModule;
